import { render, staticRenderFns } from "./PgaValutazioneOffertaTotaliOffertaCreate.vue?vue&type=template&id=aa5d2898&"
import script from "./PgaValutazioneOffertaTotaliOffertaCreate.vue?vue&type=script&lang=ts&"
export * from "./PgaValutazioneOffertaTotaliOffertaCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VChip,VCol,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa5d2898')) {
      api.createRecord('aa5d2898', component.options)
    } else {
      api.reload('aa5d2898', component.options)
    }
    module.hot.accept("./PgaValutazioneOffertaTotaliOffertaCreate.vue?vue&type=template&id=aa5d2898&", function () {
      api.rerender('aa5d2898', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/ValutazioneOfferta/Components/PgaValutazioneOffertaTotaliOffertaCreate.vue"
export default component.exports